/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_CtaInputs */

const en_landing_hero_cta = /** @type {(inputs: Landing_Hero_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Started`)
};

const zh_landing_hero_cta = /** @type {(inputs: Landing_Hero_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即开始`)
};

/**
* | output |
* | --- |
* | "Get Started" |
*
* @param {Landing_Hero_CtaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_hero_cta = /** @type {((inputs?: Landing_Hero_CtaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_CtaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_hero_cta(inputs)
	return zh_landing_hero_cta(inputs)
});
export { landing_hero_cta as "landing.hero.cta" }